import { useMemo } from "react";
import { Alert, IconButton, Collapse } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { EnrichmentSynchronizationState } from "../types";
import { DETAILS_PAGE_TEXTS } from "../consts";
import { useSalesforceIntegrationDetailsContext } from "../contexts/useSalesforceIntegrationDetailsContext";

export const ReminderBanner: React.FC = () => {
  const {
    synchronizationState,
    integration,
    showReminderBanner,
    setShowReminderBanner,
  } = useSalesforceIntegrationDetailsContext();
  const { shouldShow, message } = useMemo(() => {
    const isFirstIntegration =
      synchronizationState ===
      EnrichmentSynchronizationState.NEVER_RAN_MATCHING;
    const isSyncInProgress =
      synchronizationState === EnrichmentSynchronizationState.SYNC_IN_PROGRESS;

    if (!showReminderBanner || isSyncInProgress) {
      return {
        shouldShow: false,
        message: "",
      };
    }

    if (isFirstIntegration) {
      return {
        shouldShow: true,
        message: DETAILS_PAGE_TEXTS.banners.firstIntegrationWelcome,
      };
    }

    if (integration.needsResync) {
      return {
        shouldShow: true,
        message: DETAILS_PAGE_TEXTS.banners.resyncWelcome,
      };
    }

    return {
      shouldShow: false,
      message: "",
    };
  }, [showReminderBanner, synchronizationState, integration.needsResync]);

  return (
    <Collapse in={shouldShow}>
      <Alert
        severity="info"
        sx={{ mb: 2, alignItems: "center" }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => setShowReminderBanner(false)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {message}
      </Alert>
    </Collapse>
  );
};
